import * as Yup from 'yup';

export type TFormValues = {
  code: string;
};

export const initialValues: TFormValues = {
  code: '',
};

export const validationSchema = Yup.object().shape({
  code: Yup.string().required('validation.required'),
});
